import { BaseButton, type BaseButtonProps } from './BaseButton';

type Props = BaseButtonProps;

export const TertiaryButton = (props: Props) => {
  return <BaseButton variant="tertiary" {...props} />;
};
